import { Marker } from "react-map-gl";
import { Place } from "../api";
import { Typography } from "@mui/material";
import { Box } from "@mui/material";
import FastfoodIcon from "@mui/icons-material/Fastfood";
import { useState } from "react";

export const PlaceMarker = ({ place }: { place: Place }) => {
  const [hovered, setHovered] = useState(false);
  return (
    <Marker longitude={place.location.lng} latitude={place.location.lat}>
      <Box
        sx={{
          backgroundColor: "white",
          borderRadius: "5px",
          opacity: 0.8,
        }}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
      >
        <Box display="flex" flexDirection="column" alignItems="center">
          {hovered && (
            <Box
              sx={{
                position: "absolute",
                top: -50,
                backgroundColor: "white",
                borderRadius: "5px",
                padding: "5px",
                opacity: 1.0,
                width: "200px",
              }}
            >
              <Typography variant="caption" sx={{ fontSize: "14px" }}>
                {place.name}
              </Typography>
            </Box>
          )}
          <FastfoodIcon />
        </Box>
      </Box>
    </Marker>
  );
};